import './style.sass';
import React, { useCallback } from 'react';
import { ReactSVG } from 'react-svg';
import checkIcon from 'assets/img/icons/check-icon.svg';

type Props = {
    isActive: boolean,
    onClickItem: () => void,
    text: string,
    textClassName?: string,
    className?: string,
    type?: 'default' | 'light' | 'light-2',
};

export const SelectItem = ({
    isActive,
    onClickItem,
    text,
    textClassName,
    className,
    type = 'default',
}: Props) => {
    const textClass = textClassName
        ? `select-item__text ${textClassName}`
        : `select-item__text p1-regular  ${type === 'default' ? 'white-text' : 'dark-violet'}`;

    const selectItemClass = `select-item ${className ? className : ''} select-item--${type} ${isActive ? 'active' : ''}`;

    const handleClickOnItem = useCallback((e: React.MouseEvent) => {
        e.preventDefault();
        e.stopPropagation();

        if (onClickItem) {
            onClickItem();
        }

    }, [onClickItem]);

    return (
        <div
            className={selectItemClass}
            onClick={handleClickOnItem}
        >
            <span className={textClass}>{text}</span>

            <div className={`select-item__check-icon ${isActive ? 'active' : ''}`}>
                <ReactSVG src={checkIcon} />
            </div>
        </div>
    );
};
